import FetchHelper from 'libs/fetchcontroller.js';
import config from 'libs/config';
import logger from '@/plugins/logger.js';
import urljoin from 'url-join';

export default class ApiController {
  constructor (baseuri) {
    this.baseuri = baseuri;
  }
  async Post (relativeuri, body) {
    if (config.debug) {
      console.log('post', relativeuri, body);
    }
    return FetchHelper.post(this.geturi(relativeuri), body);
  }
  async Get (relativeuri, body) {
    if (config.debug) {
      console.log('get', relativeuri, body);
    }
    return FetchHelper.get(this.geturi(relativeuri), body);
  }
  async Put (relativeuri, body) {
    return FetchHelper.put(this.geturi(relativeuri), body);
  }

  get BaseURI() {
    let result = config.getBase;
    return result;
  }

  static get BaseURI() {
    let result = config.getBase;
    return result;
  }

  geturi (relativeuri) {
    let result = urljoin(this.BaseURI, relativeuri);
    logger.log('BaseURI', this.BaseURI, 'uri', result);
    return result;
  }
}

export class CustomHeaderApiController {
  constructor (baseuri, headers) {
    this.baseuri = baseuri;
    this.headers = headers;
  }
  async Get (relativeuri, body) {
    if (config.debug) {
      console.log('get', relativeuri, body);
    }
    return FetchHelper.getWithHeaders(this.geturi(relativeuri), body, this.headers);
  }

  geturi (relativeuri) {
    let result = urljoin(config.getBase, this.baseuri, relativeuri);
    return result;
  }
}